export default __webpack_public_path__ + "cee5898a8f2dc956e45f78731e0ad1e0.svg";